import { getWorkflowTypes } from "@/api/workflow";
import { IWorkflowType } from "@/interfaces/workflow-type.interface";
import { PaginatedResponse, RequestPagination } from "@/types/requests.types";

class WorkflowTypeService {
  async getAllWorkflowTypes(
    pagination: RequestPagination
  ): Promise<PaginatedResponse<IWorkflowType>> {
    return getWorkflowTypes(pagination);
  }
}

const workflowTypeService = new WorkflowTypeService();
export default workflowTypeService;
